import { Component, OnInit, inject, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CURRENT_PREFIX } from 'src/app/utils/item.util';
import { ContentCardComponent } from '../../../shared-modules/content-card/content-card.component';
import { ResultsTableComponent } from './results-table/results-table.component';
import { SaveWarningDialogContainerComponent } from '../../../shared-modules/save-warning-dialog/save-warning-dialog-container.component';
import { BreadcrumbComponent, BreadcrumbItem } from '../../../shared-modules/breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-results-page',
    templateUrl: './results-page.component.html',
    styleUrls: ['./results-page.component.scss'],
    imports: [ContentCardComponent, ResultsTableComponent, SaveWarningDialogContainerComponent, BreadcrumbComponent]
})
export class ResultsPageComponent implements OnInit {
  private route = inject(ActivatedRoute);

  public isCurrentSituation!: boolean;

  readonly pdfExportIsCurrentSituation = input<boolean>();

  get breadcrumbs(): BreadcrumbItem[] {
    const label = this.isCurrentSituation
      ? 'Resultaten - Beeldvorming huidige situatie'
      : 'Resultaten - Beeldvorming toekomstige situatie';
    return [
      { label: 'Home', link: '/landing-page' },
      { label }
    ];
  }

  ngOnInit(): void {
    const pdfExportIsCurrentSituation = this.pdfExportIsCurrentSituation();
    if (pdfExportIsCurrentSituation === undefined) {
      this.route.url.subscribe(urlSegments => {
        this.isCurrentSituation = urlSegments[urlSegments.length - 1].path === CURRENT_PREFIX;
      });
    } else {
      this.isCurrentSituation = pdfExportIsCurrentSituation;
    }
  }
}
